import type {State} from 'src/reducers';
import {AuthenticationStatus} from 'src/reducers/authentication';
import type {ApiErrorWithStatusCode} from 'src/types/authentication';

import type {Agency} from 'src/types/agency';


export const selectMfaCredsValidating = (state: State): boolean =>
  state.authentication?.credAuthenticationStatus ===
  AuthenticationStatus.AUTHENTICATING;

export const selectMfaCredsError = (state: State): boolean =>
  state.authentication?.credAuthenticationStatus === AuthenticationStatus.ERROR;

export const selectMfaAuthChannel = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'auth_channel' does not exist on type 'MfaSettings'.
  state.authentication?.authenticationData?.mfa_settings?.auth_channel;

export const selectUserPhoneNumber = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'phone_number' does not exist on type 'MfaSettings'.
  state.authentication?.authenticationData?.mfa_settings?.phone_number;

export const selectUserLoginId = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'login_id' does not exist on type 'AuthenticationData'.
  state.authentication?.authenticationData?.login_id;

export const selectUserEmail = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'email_id' does not exist on type 'MfaSettings'.
  state.authentication?.authenticationData?.mfa_settings?.email_id;

export const selectUserNewPhoneNumber = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'newPhone' does not exist on type 'AuthenticationState'.
  state.authentication?.newPhone;

export const selectCurrentAgency = (state: State): Agency =>
  // @ts-expect-error - TS2339 - Property 'agency' does not exist on type 'AuthenticationData'.
  state.authentication?.authenticationData?.agency;

export const selectSignInError = (state: State): string | null | undefined =>
  state.authentication?.signInError;

export const selectRetryInMins = (state: State): number =>
  // @ts-expect-error - TS2339 - Property 'retryInMins' does not exist on type 'AuthenticationState'.
  state.authentication?.retryInMins;

export const selectOtpVerificationError = (
  state: State,
): ApiErrorWithStatusCode =>
  // @ts-expect-error - TS2339 - Property 'otpVerificationError' does not exist on type 'AuthenticationState'.
  state.authentication?.otpVerificationError;

export const selectNewPhoneRegistrationError = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'newPhoneRegistrationError' does not exist on type 'AuthenticationState'.
  state.authentication?.newPhoneRegistrationError;

export const selectResendOtpError = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'resendOTPError' does not exist on type 'AuthenticationState'.
  state.authentication?.resendOTPError;

export const selectResetMfaDeviceError = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'resetMfaDeviceError' does not exist on type 'AuthenticationState'.
  state.authentication?.resetMfaDeviceError;

export const selectResetPhoneApproveError = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'resetPhoneApproveError' does not exist on type 'AuthenticationState'.
  state.authentication?.resetPhoneApproveError;

export const selectResetPhoneApproved = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'resetPhoneApproved' does not exist on type 'AuthenticationState'.
  state.authentication?.resetPhoneApproved;

export const selectValidAgencies = (
  state: State,
): Agency[] | null | undefined => state.authentication?.validAgencies;

export const selectForgotPasswordError = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'forgotPasswordError' does not exist on type 'AuthenticationState'.
  state.authentication?.forgotPasswordError;

export const selectResetPasswordError = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'resetPasswordError' does not exist on type 'AuthenticationState'.
  state.authentication?.resetPasswordError;

export const selectSignUpError = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'signUpError' does not exist on type 'AuthenticationState'.
  state.authentication?.signUpError;

export const selectOtpLimitExceeded = (state: State): boolean =>
  // @ts-expect-error - TS2339 - Property 'otpLimitExceeded' does not exist on type 'AuthenticationState'.
  state.authentication?.otpLimitExceeded;

export const selectTotpDetails = (state: State): boolean =>
  // @ts-expect-error - TS2339 - Property 'totp_details' does not exist on type 'MfaSettings'.
  state.authentication.authenticationData?.mfa_settings?.totp_details;

export const selectShouldEnrollTotp = (state: State): boolean =>
  // @ts-expect-error - TS2339 - Property 'should_enroll_totp' does not exist on type 'MfaSettings'.
  state.authentication.authenticationData?.mfa_settings?.should_enroll_totp;

export const selectResetTotpApproveError = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'resetTotpApproveError' does not exist on type 'AuthenticationState'.
  state.authentication?.resetTotpApproveError;

export const selectResetTotpApproved = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'resetTotpApproved' does not exist on type 'AuthenticationState'.
  state.authentication?.resetTotpApproved;

export const selectChannelSelectionTotpError = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'channelSelectionTotpError' does not exist on type 'AuthenticationState'.
  state.authentication?.channelSelectionTotpError;
